// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionCardWrapper_container__Jh2ZM","loaderContainer":"SubscriptionCardWrapper_loaderContainer__wPh_A"};